var map = {
	"./culture/limiting.svg": "2cb2",
	"./fonts/mdi/materialdesignicons-webfont.svg": "f260e",
	"./home/custom-poll/groups-icon.svg": "0c0d",
	"./home/custom-poll/ico-paragraph-disabled.svg": "2418",
	"./home/custom-poll/ico-paragraph.svg": "c2d0",
	"./home/custom-poll/ico-percent-disabled.svg": "bf36",
	"./home/custom-poll/ico-percent.svg": "7833",
	"./home/custom-poll/ico-radio-disabled.svg": "1fba",
	"./home/custom-poll/ico-radio.svg": "e4b7",
	"./home/custom-poll/sender-company-disabled.svg": "4002",
	"./home/custom-poll/sender-company-name.svg": "5374",
	"./home/custom-poll/sender-owner-disabled.svg": "bcc4",
	"./home/custom-poll/sender-owner.svg": "a9a1",
	"./home/dashboard/bg-widget-custom-poll.svg": "2927",
	"./home/dashboard/bg-widget-feedback.svg": "b045",
	"./home/dashboard/bg-widget-group.svg": "0701",
	"./home/dashboard/bg-widget-question.svg": "faa8",
	"./home/dashboard/bg-widget-report.svg": "1b6c",
	"./home/dashboard/bg-widget-send-feedback.svg": "581d",
	"./home/dashboard/bg-widget-user.svg": "e434",
	"./home/dashboard/img-widget-custom-poll.svg": "9e7a",
	"./home/dashboard/img-widget-feedback.svg": "58eb",
	"./home/dashboard/img-widget-group.svg": "9033",
	"./home/dashboard/img-widget-question.svg": "387a",
	"./home/dashboard/img-widget-report.svg": "b42c",
	"./home/dashboard/img-widget-send-feedback.svg": "6db5",
	"./home/dashboard/img-widget-user.svg": "002a",
	"./home/empty-state-custom-survey.svg": "919b",
	"./home/feedbacks/axo_feliz.svg": "0426",
	"./home/feedbacks/axo_triste.svg": "cd55",
	"./home/feedbacks/export.svg": "251a",
	"./home/feedbacks/human-greeting.svg": "5a14",
	"./home/feedbacks/preload.svg": "cd78e",
	"./home/feedbacks/round-chat_bubble-24px.svg": "22f85",
	"./home/feedbacks/round-group-24px.svg": "3a87",
	"./home/feedbacks/round-keyboard_arrow_right-24px.svg": "3a05",
	"./home/feedbacks/round-more_horiz-24px.svg": "2dfa",
	"./home/feedbacks/round-send-24px.svg": "2220",
	"./home/feedbacks/round-tune-24px.svg": "a707",
	"./home/feedbacks/user.svg": "8f3d",
	"./homescreen/icon_axel.svg": "da31",
	"./homescreen/icon_teamculture.svg": "838f",
	"./icons/alignment.svg": "acad",
	"./icons/ambassadorship.svg": "dbb0",
	"./icons/averageScore.svg": "ccd3",
	"./icons/feedback.svg": "eaaf",
	"./icons/foward.svg": "73f8",
	"./icons/fowardSimple.svg": "a14a",
	"./icons/happiness.svg": "e862",
	"./icons/iconLogout.svg": "0037",
	"./icons/languages/en-US.svg": "beac",
	"./icons/languages/es-AR.svg": "b320",
	"./icons/languages/pt-BR.svg": "3428",
	"./icons/loading.svg": "1e31",
	"./icons/managerRelationship.svg": "c3e6",
	"./icons/participation.svg": "6724",
	"./icons/peersRelationship.svg": "2756",
	"./icons/personalGrowth.svg": "3d5c",
	"./icons/recognition.svg": "9617",
	"./icons/recommendation/benefit-icon.svg": "9b49",
	"./icons/recommendation/how-icon.svg": "34dc",
	"./icons/recommendation/what-icon.svg": "3ef3",
	"./icons/round-close.svg": "3bcd",
	"./icons/satisfaction.svg": "f714",
	"./icons/shared/round-language.svg": "46b4",
	"./icons/toward.svg": "8bfb",
	"./icons/towardSimple.svg": "60ce",
	"./icons/wellness.svg": "f08c",
	"./login/icon_erro.svg": "4dfc",
	"./login/mail_amarelo.svg": "bf4a",
	"./logos/icon.svg": "039d",
	"./logos/logo.svg": "df2f",
	"./logos/logo_black.svg": "f1c4",
	"./logos/logo_inline.svg": "50d2",
	"./logos/logo_inline_black.svg": "4ff3",
	"./messages/icon_group.svg": "864f",
	"./messages/icon_network.svg": "3aba",
	"./metrics/alinhamento.svg": "c247",
	"./metrics/bemestar.svg": "069a",
	"./metrics/crescimento_pessoal.svg": "8984",
	"./metrics/enps.svg": "0b31",
	"./metrics/feedback.svg": "57af",
	"./metrics/felicidade.svg": "c121",
	"./metrics/reconhecimento.svg": "cae2",
	"./metrics/relacao_equipe.svg": "c388",
	"./metrics/relacao_gestor.svg": "c3f4",
	"./metrics/satisfacao.svg": "a49e",
	"./metrics/vector.svg": "29d0",
	"./navigation/advanced-survery-active.svg": "325d",
	"./navigation/advanced-survery.svg": "c01c",
	"./navigation/custom-survery-active.svg": "8118",
	"./navigation/custom-survery.svg": "e042",
	"./navigation/engagement-active.svg": "1757",
	"./navigation/engagement.svg": "2e5b",
	"./navigation/growth-active.svg": "dc4b",
	"./navigation/growth.svg": "d794",
	"./navigation/home-active.svg": "36c8",
	"./navigation/home.svg": "16f9",
	"./navigation/logo-b.svg": "b044",
	"./navigation/logo.svg": "3fc0",
	"./navigation/management-active.svg": "5e55",
	"./navigation/management.svg": "8d47a",
	"./navigation/opinions-active.svg": "140e",
	"./navigation/opinions.svg": "7467",
	"./navigation/performance-active.svg": "4ec2",
	"./navigation/performance.svg": "6f8b",
	"./navigation/recognition-active.svg": "1db9",
	"./navigation/recognition.svg": "8967",
	"./new-engagement/engagement.svg": "6cc2",
	"./payment/axel-success.svg": "4112",
	"./payment/boleto.svg": "8e1a",
	"./payment/master.svg": "40e3",
	"./payment/trial-to-basic-custom-poll-mobile.svg": "4704",
	"./payment/trial-to-basic-custom-poll.svg": "8b12",
	"./payment/trial-to-basic-group-mobile.svg": "5e42",
	"./payment/trial-to-basic-group.svg": "534c",
	"./payment/vector.svg": "e64b",
	"./payment/visa.svg": "2af7",
	"./radial-counter.svg": "b596",
	"./survey/ico-survey-begin.svg": "b831",
	"./survey/ico-survey-conclusion.svg": "5285",
	"./survey/ico_survey_home.svg": "34f1",
	"./survey/icon_survey.svg": "78b1",
	"./survey/surbey_header.svg": "19f0",
	"./tooltip_ask.svg": "d9f3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";